import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';
import classNames from 'classnames';

const SelectionBubble = ({
  className = '',
  id = '',
  label,
  style = {},
  title = '',
  selected,
  hideClose = false,
  onClick,
  onLabelClick = null,
  clickable = false,
}) => {
  const handleClick = () => {
    onClick(selected);
  };

  const handleLabelClick = () => {
    onLabelClick && clickable && onLabelClick(selected);
  }

  const buttonClass = () => classNames('flex-auto text-action-blue', {
    'hover:underline': clickable,
    'pointer-events-none': !clickable,
  });

  return (
    <div
      id={id}
      className={`bg-medium-fill-blue rounded-full border border-action-blue inline-block mb-1.5 mr-2.5 px-3 py-1 select-none leading-4 text-xs font-regular-font ${className}`}
      style={style}
      title={title}
    >
      <div className="flex items-center">
        <button className={buttonClass()} onClick={handleLabelClick} aria-label={label}>{label}</button>
        {!hideClose && (
          <Icon
            type="button"
            className="bg-transparent cursor-pointer ml-2 text-action-blue hover:text-deep-blue"
            aria-label={`${label}-cross`}
            icon="Cross"
            size={8}
            onClick={handleClick}
            color="action-blue"
          />
        )}
      </div>
    </div>
  );
};

SelectionBubble.propTypes = {
  className: PropTypes.string,
  hideClose: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onLabelClick: PropTypes.func,
  style: PropTypes.object,
  selected: PropTypes.object.isRequired,
  title: PropTypes.string,
  clickable: PropTypes.bool,
};

export default SelectionBubble;
